<div class="theme-language-container">
  <button
    mat-flat-button
    (click)="store.setDarkMode(); $event.stopPropagation()"
    class="theme-button"
  >
    <mat-icon>{{ store.darkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    {{ store.darkMode() ? ('lightMode' | translate | async) : ('darkMode' | translate | async) }}
  </button>
  <!-- TODO when user has language property, change the logic -->
  <mat-select
    [value]="store.language()"
    (selectionChange)="store.setLanguage($event.value)"
    class="language-selector"
  >
    @for (lang of availableLanguages; track lang) {
    <mat-option [value]="lang.value">{{ lang.viewValue }}</mat-option>
    }
  </mat-select>
</div>
